import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { azureADUser } from '../models/azureAD-User.model';
import { AzureADOrg } from '../models/azureADOrg.model';
import { environment } from '../../environments/environment';
import { XWareLogService } from './xware-log.service';
import { IDirectoryService } from './idirectory.service';

@Injectable({
  providedIn: 'root',
})
export class DirectoryService implements IDirectoryService {
  public directoryUrl = environment.portalapiurl + '/directory';
  public profilePic: BehaviorSubject<Blob[] | null> = new BehaviorSubject<Blob[] | null>(null);

  constructor(
    private http: HttpClient,
    private logger: XWareLogService
  ) {}

  public getOrg(): Observable<AzureADOrg> {
    return this.http
      .get<AzureADOrg>(`${this.directoryUrl}/getOrganisation`, { responseType: 'json' })
      .pipe(
        map(data => {
          this.logger.log('directory: getOrg ' + JSON.stringify(data));
          return { value: [data] } as unknown as AzureADOrg;
        })
      );
  }

  public getUserInfo(): Observable<azureADUser> {
    return this.http.get<azureADUser>(`${this.directoryUrl}/getCurrentUser`).pipe(
      map(data => {
        this.logger.log('directory: getUserInfo:' + JSON.stringify(data));
        return data;
      })
    );
  }

  public getProfilePic(): Observable<Blob> {
    const userKey =
      sessionStorage.getItem('user_id') || sessionStorage.getItem('userPrincipalName') || '';
    return this.http.get(`${this.directoryUrl}/getPhoto?userKey=${encodeURIComponent(userKey)}`, {
      responseType: 'blob',
    });
  }
}
